import React, { useState, useEffect, useContext } from "react";
import { Button, Table, Form, Row, Col, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomTooltip from "utils/CustomTooltip";
import { v4 as uuidv4 } from "uuid";
import CustomSwitch from "utils/CustomSwitch";
import PointsofContact from "../client_config/account_config/services_agreement/PointsOfContact";
import PpcSupportingRoles from "../client_config/account_config/services_agreement/ppc/PpcSupportingRoles";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import CustomFormCheck from "utils/CustomFormCheck";
import { RouterContext } from "./Onboarding";

export default function PPCServiceAgreements(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);
  props.pageLocator();
  const isPpcEnabled = props[`searchEnabled`] || props[`socialEnabled`] || props[`displayEnabled`] || props[`videoEnabled`];
  const [isChecked, setIsChecked] = useState(isPpcEnabled);
  const [searchValidation, setSearchValidation] = useState(false)
  const [socialValidation, setSocialValidation] = useState(false)
  const [displayValidation, setDisplayValidation] = useState(false)
  const [videoValidation, setVideoValidation] = useState(false)
  const [validated, setValidation] = useState(true);
  const removeRow = (id, selector) => {
    if (!isChecked) {
      return undefined;
    }
    if (selector == "1") {
      const newArray = props.ppcFeeStructure.filter((el) => el.id !== id);

      props.setPpcFeeStructure([...newArray]);
    }
    if (selector == "2") {
      const newArray = props.ppcFees.filter((el) => el.id !== id);
      props.setPpcFees([...newArray]);
    }
  };
  const ppcStartDate = new Date(props.ppcStartDate);

  const validator = () => {
    setSearchValidation(false)
    setSocialValidation(false)
    setVideoValidation(false)
    setDisplayValidation(false)
    setValidation(false);
    if (!isChecked || (props.ppcFeeStructure.length > 0 && props.ppcPointsOfContact.length > 0 && ppcStartDate.getFullYear() > 2000)) {
      if (props.searchEnabled) {
        if (props.searchAccountLeads.length === 0 || props.searchAccountSupports.length === 0) {
           setSearchValidation(false)
        }
        if (props.searchAccountLeads.length > 0 && props.searchAccountSupports.length > 0)
          if (props.searchUniqueFeeEnabled === false) {
             setSearchValidation(true)
          } else if  (props.searchFeeStructure.length > 0) setSearchValidation(true);
        else  setSearchValidation(false);
      }
      else {
        setSearchValidation(true)
      }
      if (props.socialEnabled) {
        if (props.socialAccountLeads.length === 0 || props.socialAccountSupports.length === 0) {
           setSocialValidation(false)
        }
        if (props.socialAccountLeads.length > 0 && props.socialAccountSupports.length > 0)
          if (props.socialUniqueFeeEnabled === false) {
             setSocialValidation(true)
          } else if  (props.socialFeeStructure.length > 0) setSocialValidation(true);
        else  setSocialValidation(false);
      }
      else {
        setSocialValidation(true)
      }
      if (props.videoEnabled) {
        if (props.videoAccountLeads.length === 0 || props.videoAccountSupports.length === 0) {
           setVideoValidation(false)
        }
        if (props.videoAccountLeads.length > 0 && props.videoAccountSupports.length > 0)
          if (props.videoUniqueFeeEnabled === false) {
             setVideoValidation(true)
          } else if  (props.videoFeeStructure.length > 0) setVideoValidation(true);
        else  setVideoValidation(false);
      } else {
        setVideoValidation(true)
      }
      if (props.displayEnabled) {
        if (props.displayAccountLeads.length === 0 || props.displayAccountSupports.length === 0) {
           setDisplayValidation(false)
        }
        if (props.displayAccountLeads.length > 0 && props.displayAccountSupports.length > 0)
          if (props.searchUniqueFeeEnabled === false) {
             setDisplayValidation(true)
          } else if  (props.displayFeeStructure.length > 0) setDisplayValidation(true);
        else  setDisplayValidation(false);
      } 
      else {
        setDisplayValidation(true)
      }
      if (searchValidation === true && socialValidation === true && videoValidation === true && displayValidation === true) {setValidation(true)}
        if (!props.searchEnabled && !props.displayEnabled && !props.socialEnabled && !props.videoEnabled) setValidation(true);
      }
    else {
      setValidation(false);
    }
  }

  useEffect(() => validator());
  return (
    <>
      <div>
        <Row className="mb-3 pb-3 justify-content-center">
          <Col md={7}>
            <div>
              <p className="pb-3 f28 visby-bold primary text-center">PPC Service Agreements</p>
            </div>
            <div>
              <p className=" f14 nunito-regular primary ">
                Please configure the PPC service agreements below for both overall PPC and by sub-service. We have already enabled any services that you have
                indicated in the beginning of onboarding, but you can make changes here if need be.
              </p>
            </div>
          </Col>
        </Row>
        <Row className="mb-4 justify-content-center">
          <Col md={6}>
          <p>To complete:</p>
          <br></br>
          <p><strong>Step 1:</strong> Choose which services should be enabled</p>
          <p><strong>Step 2:</strong> Choose a start date for each service</p>
          <p><strong>Step 3:</strong> Fill in invoicing information (add fees if applicable)</p>
          <p><strong>Step 4:</strong> Assign points of contact, leads and supports (must assign for every service)</p>
          </Col>
        </Row>
        <div className="px-5 pb-5 ppc-service-agreements" style={{ backgroundColor: "#E1E1E1", paddingTop: "40px" }}>
          <Row>
            <Col className="text-right">
              <NextButton
                validated={validated}
                btnText={`Next`}
                nextPage={nextPage.url}
                invalidText={`We need more information on this page before you continue.`}
                submitForm={props.submitForm}
              />
            </Col>
          </Row>

          <div>
            <div>
              <div className={`px-5 pt-5 collapse-padding-mobile ${isChecked ? undefined : "top-div"}`} style={{ backgroundColor: "#EEEEEE" }}>
                <CustomSwitch
                  isEnabled={isChecked}
                  setIsEnabled={setIsChecked}
                  text="PPC"
                  label={
                    <p className="ppc-color pb-0 f28 visby-bold pl-3 mb-0" style={{ marginTop: "-5px" }}>
                      PPC
                    </p>
                  }
                  variant="ppc"
                  customClass="d-inline-block"
                  id="ob-agree-ppc-enable"
                />
                <div style={isChecked ? undefined : { display: "none" }}>
                  <Row style={isChecked ? undefined : { display: "none" }} className="d-flex">
                    <Col className="d-flex flex-column" xs={12} xl={9}>
                      <p className="f22 visby-bold light-primary mb-3">Agreement</p>
                      <div className="shared-fee-structure mb-5">
                        <div className="table-responsive pb-3">
                          <Table>
                            <thead>
                              <tr>
                                <th className="pl-1" style={{ width: "340px" }}>
                                  <p className="d-inline-block pr-2 f16 light-primary visby-bold">Select and set shared fee structure</p>
                                  <CustomTooltip
                                    faClass="far primary fa-question-circle"
                                    message="This is where you can dictate how a client will be charged based on their ad spend. You can set multiple thresholds for ad spend on the left, and then tell DataPulse whether you would like to charge a fixed dollar amount, or a percentage of that ad spend for each threshold with the boxes on the right. In the case of charging a percentage, you can also specify whether you would like to charge a percentage of the total ad spend, or only the percentage of the amount that is over the specified threshold."
                                    inline={true}
                                  />
                                </th>
                                <th style={{ paddingLeft: "35px", width: "100px" }}>
                                  <p
                                    style={props.ppcFeeStructure.length === 0 ? { display: "none" } : undefined}
                                    className="f12 pl-0 nunito-regular  light-primary">
                                    Fixed amount
                                  </p>
                                </th>
                                <th>
                                  {" "}
                                  <p
                                    style={props.ppcFeeStructure.length === 0 ? { display: "none" } : undefined}
                                    className="f12 pl-4 nunito-regular light-primary">
                                    % of ad spend (total or above)
                                  </p>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {props.ppcFeeStructure.map((el, index) => {
                                const flatFeeEnabled = el["flat_fee_enabled"] == "1";
                                const percentageEnabled = el["percentage_fee_enabled"] == "1";
                                const greyout1 = flatFeeEnabled ? null : { opacity: "0.6" };
                                const greyout2 = percentageEnabled ? null : { opacity: "0.6" };
                                return (
                                  <tr key={el.id ? el.id : uuidv4()}>
                                    <td className="pr-0">
                                      <div className=" d-flex  align-items-center">
                                        <p className="f12 pr-2 resize primary">Over ad spend</p>
                                        <div className="input-box4 pr-2">
                                          <Form.Control
                                            disabled={!isChecked}
                                            size="sm"
                                            className="cw1"
                                            placeholder="0"
                                            value={el.over_ad_spend ? el.over_ad_spend : ""}
                                            onChange={(e) => {
                                              let newArray = props.ppcFeeStructure;
                                              newArray[index]["over_ad_spend"] = e.target.value;
                                              props.setPpcFeeStructure([...newArray]);
                                            }}
                                          />

                                          <span className="unit">$</span>
                                        </div>
                                        <p className="f12 primary">charge</p>
                                      </div>
                                    </td>
                                    <td className="pl-0 pr-3">
                                      <div className="d-flex pl-0 align-items-center">
                                        <div style={{ width: "26px" }} className="pr-0">
                                          <CustomFormCheck
                                            checked={flatFeeEnabled}
                                            onChange={(e) => {
                                              let newArray = props.ppcFeeStructure;
                                              newArray[index]["flat_fee_enabled"] = flatFeeEnabled ? "0" : "1";
                                              props.setPpcFeeStructure([...newArray]);
                                            }}
                                            id={`ppcagreecharge ` + `${index}`}
                                          />
                                        </div>
                                        <div className="input-box2">
                                          <Form.Control
                                            disabled={!flatFeeEnabled}
                                            style={greyout1}
                                            size="sm"
                                            className="cw2"
                                            placeholder="0"
                                            value={el.flat_fee ? el.flat_fee : ""}
                                            onChange={(e) => {
                                              let newArray = props.ppcFeeStructure;
                                              newArray[index]["flat_fee"] = e.target.value;
                                              props.setPpcFeeStructure([...newArray]);
                                            }}
                                          />
                                          <span
                                            style={{
                                              opacity: flatFeeEnabled ? undefined : "0.6",
                                            }}
                                            className="unit">
                                            $
                                          </span>
                                        </div>
                                      </div>
                                    </td>
                                    <td className="p-0">
                                      <div className="d-flex pl-2 align-items-center">
                                        <div style={{ width: "26px" }}>
                                          <CustomFormCheck
                                            disabled={!isChecked}
                                            id={`ppcagreerev ` + `${index}`}
                                            checked={percentageEnabled}
                                            onChange={(e) => {
                                              let newArray = props.ppcFeeStructure;
                                              newArray[index]["percentage_fee_enabled"] = percentageEnabled ? "0" : "1";
                                              props.setPpcFeeStructure([...newArray]);
                                            }}
                                          />
                                        </div>
                                        <div className="mr-2">
                                          <Form.Control
                                            disabled={!percentageEnabled}
                                            style={{...greyout2, ...{minWidth: "80px"}}}
                                            className="ml-0 mr-0"
                                            value={el ? el.percentage_fee_total_over : ""}
                                            as="select"
                                            onChange={(e) => {
                                              let newArray = props.ppcFeeStructure;

                                              newArray[index]["percentage_fee_total_over"] = e.target.value;
                                              props.setPpcFeeStructure([...newArray]);
                                            }}
                                            size="sm"
                                            placeholder="0">
                                            <option value="total">total</option>
                                            <option value="above">above</option>
                                          </Form.Control>
                                        </div>
                                        <div className="input-box3 pr-4">
                                          <Form.Control
                                            disabled={!percentageEnabled}
                                            className="primary"
                                            size="sm"
                                            style={greyout2}
                                            placeholder="0"
                                            value={props.ppcFeeStructure[index]["percentage_fee"]}
                                            onChange={(e) => {
                                              let newArray = props.ppcFeeStructure;
                                              newArray[index]["percentage_fee"] = e.target.value;
                                              props.setPpcFeeStructure([...newArray]);
                                            }}
                                          />
                                          <span
                                            style={{
                                              opacity: percentageEnabled ? undefined : "0.6",
                                            }}
                                            className="unit">
                                            %
                                          </span>
                                        </div>
                                        {index >= 0 && <i onClick={() => removeRow(el.id, "1")} className="fas fa-minus-circle"></i>}
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                        <Button
                          style={{
                            paddingLeft: "45px",
                            paddingRight: "45px",
                            marginLeft: "11px",
                            width: "200px"
                          }}
                          disabled={!isChecked}
                          className="mt-3 btn-sm text-center"
                          variant="success"
                          size="sm"
                          onClick={() =>
                            props.setPpcFeeStructure([
                              ...props.ppcFeeStructure,
                              {
                                id: uuidv4(),
                                flat_fee: "0",
                                over_ad_spend: "0",
                                percentage_fee: "0",
                                flat_fee_enabled: "0",
                                percentage_fee_enabled: "0",
                                percentage_fee_total_over: "total",
                              },
                            ])
                          }>
                          + Add Condition
                        </Button>
                      </div>
                      <div className="active-ppc-fees mb-5">
                        <p className="d-inline-block pr-2 f16 light-primary visby-bold">Active PPC Fees</p>
                        <p style={{ visibility: "hidden" }} className="d-inline-block f14 ppc-color">
                          View full history
                        </p>
                        <div className="table-responsive pb-3">
                          {/* <input hidden name="current_onboarding_page" value={window.location.href} readOnly /> */}

                          <Table>
                            <thead>
                              <tr style={props.ppcFees.length === 0 ? { display: "none" } : undefined}>
                                <th style={{ width: "20px" }}></th>
                                <th style={{ width: "80px" }} className="pl-3 nunito-regular  f12 light-primary">
                                  Frequency
                                </th>
                                <th style={{ width: "100px" }} className="pl-3 nunito-regular  f12 light-primary">
                                  Label
                                </th>
                                <th style={{ width: "100px" }} className="pl-3 nunito-regular  f12 light-primary">
                                  Amount
                                </th>
                                <th style={{ visibility: "hidden" }} className="light-primary nunito-regular  f12">
                                  Status
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {props.ppcFees.map((el, index) => {
                                const greyout = el["enabled"] == "1" ? null : { opacity: "0.6" };
                                return (
                                  <tr key={el.id}>
                                    <td>
                                      <div style={{ width: "16px" }}>
                                        <CustomFormCheck
                                          disabled={!isChecked}
                                          id={`activeppc ` + `${index}`}
                                          checked={el["enabled"] == "1"}
                                          onChange={(e) => {
                                            let newArray = props.ppcFees;
                                            newArray[index]["enabled"] = el["enabled"] == "1" ? "0" : "1";
                                            props.setPpcFees([...newArray]);
                                          }}
                                        />
                                      </div>
                                    </td>
                                    <td style={greyout}>
                                      <div className="disabled-border">
                                        <Form.Control
                                          disabled={el["enabled"] === "0"}
                                          style={{ width: "102px" }}
                                          as="select"
                                          className="ml-0"
                                          size="sm"
                                          value={el["frequency"]}
                                          onChange={(e) => {
                                            let newArray = props.ppcFees;
                                            newArray[index]["frequency"] = e.target.value;
                                            props.setPpcFees([...newArray]);
                                          }}>
                                          <option value="Monthly">Monthly</option>
                                          <option value="One-time">One-time</option>
                                        </Form.Control>
                                      </div>
                                    </td>
                                    <td style={greyout}>
                                      <div className="disabled-border">
                                        <Form.Control
                                          disabled={el["enabled"] === "0"}
                                          style={{ width: "178px" }}
                                          size="sm"
                                          className="ml-0 cw1"
                                          value={el["label"]}
                                          placeholder=""
                                          onChange={(e) => {
                                            let newArray = props.ppcFees;
                                            newArray[index]["label"] = e.target.value;
                                            props.setPpcFees([...newArray]);
                                          }}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="d-flex align-items-center">
                                        <div className="input-box2">
                                          <Form.Control
                                            disabled={el["enabled"] === "0"}
                                            size="sm"
                                            style={{
                                              width: "105px",
                                              opacity: el["enabled"] === "0" ? "0.6" : undefined,
                                            }}
                                            placeholder="0"
                                            value={el["amount"]}
                                            onChange={(e) => {
                                              let newArray = props.ppcFees;
                                              newArray[index]["amount"] = e.target.value;
                                              props.setPpcFees([...newArray]);
                                            }}
                                          />
                                          <span
                                            style={{
                                              opacity: el["enabled"] === "0" ? "0.6" : undefined,
                                            }}
                                            className="unit">
                                            $
                                          </span>
                                        </div>
                                        <div className="pl-3">
                                          <i onClick={() => removeRow(el.id, "2")} className={"fas fa-minus-circle"}></i>
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <p style={{ whiteSpace: "nowrap" }} className="f12 primary">
                                        {index === 0 && ""}
                                        {index === 1 && ""}
                                        {index === 2 && ""}
                                      </p>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                        <Button
                          style={{
                            paddingLeft: "45px",
                            paddingRight: "45px",
                            marginLeft: "11px",
                            width: "200px"
                          }}
                          disabled={!isChecked}
                          className="mt-3 btn-sm"
                          variant="success"
                          size="sm"
                          onClick={() =>
                            props.setPpcFees([
                              ...props.ppcFees,
                              {
                                id: uuidv4(),
                                label: "",
                                amount: "0",
                                status: "0",
                                enabled: "0",
                                frequency: "Monthly",
                              },
                            ])
                          }>
                          + Add fee
                        </Button>
                      </div>
                    </Col>
                    <Col className="d-flex flex-column" xs={12} xl={3}>
                      <PointsofContact
                        {...props}
                        group="ppc"
                        setStartDate={props.setPpcStartDate}
                        startDate={props.ppcStartDate}
                        setPpcPointsOfContact={props.setPpcPointsOfContact}
                        setPpcWhiteLabelService={props.setPpcWhiteLabelService}
                        onboarding
                      />
                    </Col>
                  </Row>
                </div>
              </div>
              <div style={!isChecked ? { display: "none" } : undefined}>
                <div
                  style={{
                    backgroundColor: "#EEEEEE",
                    marginTop: "2px",
                  }}>
                  <p className="f22 pt-3 pl-5 visby-bold primary collapse-padding-mobile">Configure PPC subservices</p>
                </div>

                {["Search", "Social", "Display", "Video"].map((section, index) => {
                  const sectionName = section.toLowerCase();
                  const dataSet = props[`${sectionName}FeeStructure`];
                  const greyout = props[`${sectionName}UniqueFeeEnabled`] === true ? null : { opacity: "0.6" };
                  const greyout2 = props[`${sectionName}UniqueFeeEnabled`] === true ? null : { backgroundColor: "white", opacity: "0.6" };

                  const addInnerRow = () => {
                    props[`set${section}FeeStructure`]([
                      ...props[`${sectionName}FeeStructure`],
                      {
                        id: uuidv4(),
                        flat_fee: "0",
                        over_ad_spend: "0",
                        percentage_fee: "0",
                        flat_fee_enabled: "0",
                        percentage_fee_enabled: "0",
                        percentage_fee_total_over: "total",
                      },
                    ]);
                  };

                  const removeInnerRow = (id, enabled, uniqueEnabled) => {
                    props[`set${section}FeeStructure`](props[`${sectionName}FeeStructure`].filter((row) => row.id !== id));
                  };
                  return (
                    <div key={section}>
                      <div
                        className="px-5 collapse-padding-mobile"
                        style={{
                          backgroundColor: "#EEEEEE",
                          marginBottom: "2px",
                        }}>
                        <div key={index} className={`${sectionName}-subservice-agreement pt-3`}>
                          <Row className="d-flex align-items-center justify-content-between">
                            <Col className="d-flex flex-column" xs={12} xl={9}>
                              <div className="d-flex mobile-flex-column">
                                <div className="d-flex flex-column">
                                  <CustomSwitch
                                    text={section}
                                    label={
                                      <h2 className="ppc-color pb-0 pl-3 mb-0" style={{ fontSize: "22px", marginTop: "-5px" }}>
                                        {section}
                                      </h2>
                                    }
                                    variant="ppc"
                                    id={`${sectionName}-subservice`}
                                    customClass="d-inline-block"
                                    isEnabled={props[`${sectionName}Enabled`]}
                                    setIsEnabled={() => props[`set${section}Enabled`](!props[`${sectionName}Enabled`])}
                                  />
                                </div>

                                <div className="d-flex flex-column">
                                  <Form.Check
                                    style={{ color: "#7B7DA4" }}
                                    className="visby-bold ppc-serve"
                                    custom
                                    label="Add to shared fee structure"
                                    type="radio"
                                    checked={!props[`${sectionName}UniqueFeeEnabled`]}
                                    id={`${section}-shared-fee-structure`}
                                    onChange={(e) => {
                                      props[`set${section}UniqueFeeEnabled`](false);
                                    }}
                                    disabled={!props[`${sectionName}Enabled`]}
                                  />
                                  <Form.Check
                                    name={`[billing_config][${section}][fee_structure_enabled]`}
                                    className="visby-bold ppc-serve"
                                    custom
                                    label="Use unique fee structure"
                                    type="radio"
                                    checked={props[`${sectionName}UniqueFeeEnabled`]}
                                    id={`${section}-unique-fee-structure`}
                                    onChange={(e) => {
                                      props[`set${section}UniqueFeeEnabled`](true);
                                    }}
                                    disabled={!props[`${sectionName}Enabled`]}
                                  />
                                </div>
                              </div>
                              <div style={{display: !props[`${sectionName}Enabled`] || props[`${sectionName}UniqueFeeEnabled`] == "0" ? "none" : undefined }} className="table-responsive pb-3">
                                <Table>
                                  <tbody>
                                    {props[`${sectionName}FeeStructure`] &&
                                      props[`${sectionName}FeeStructure`].map((el, index) => {
                                        const flatFeeEnabled = el["flat_fee_enabled"] == "1";

                                        const percentageEnabled = el["percentage_fee_enabled"] == "1";
                                        const greyout1 =
                                          props[`${sectionName}UniqueFeeEnabled`] === true && flatFeeEnabled === true ? null : { opacity: "0.6" };
                                        const greyout2 = props[`${sectionName}UniqueFeeEnabled`] === true && percentageEnabled ? null : { opacity: "0.6" };
                                        return (
                                          <tr key={`${section}${el.id}`}>
                                            <td style={{ width: "340px" }}>
                                              <div className=" d-flex  align-items-center">
                                                <p className="f12 pr-2 resize primary">Over ad spend</p>

                                                <div className="input-box4 pr-3">
                                                  <Form.Control
                                                    style={greyout}
                                                    name={`${sectionName}_fee_structure[][over_ad_spend]`}
                                                    disabled={!props[`${sectionName}Enabled`] || !props[`${sectionName}UniqueFeeEnabled`]}
                                                    size="sm"
                                                    className="cw1"
                                                    placeholder="0"
                                                    value={el.over_ad_spend ? el.over_ad_spend : ""}
                                                    onChange={(e) => {
                                                      let newArray = props[`${sectionName}FeeStructure`];
                                                      newArray[index]["over_ad_spend"] = e.target.value;
                                                      props[`set${section}FeeStructure`]([...newArray]);
                                                    }}
                                                  />

                                                  <span style={{ opacity: props[`${sectionName}UniqueFeeEnabled`] ? null : "0.6" }} className="unit">
                                                    $
                                                  </span>
                                                </div>
                                                <p className="f12 primary">charge</p>
                                              </div>
                                            </td>
                                            <td style={{ width: "100px" }}>
                                              <div className="d-flex pl-0 pr-2 align-items-center">
                                                <div style={{ width: "16px" }} className="mr-2">
                                                  <CustomFormCheck
                                                    className="mr-2"
                                                    style={greyout2}
                                                    disabled={!props[`${sectionName}Enabled`] || props[`${sectionName}UniqueFeeEnabled`] == "0"}
                                                    id={`${section}-ppcagreecharge-${index}`}
                                                    checked={flatFeeEnabled}
                                                    onChange={(e) => {
                                                      let newArray = props[`${sectionName}FeeStructure`];
                                                      newArray[index]["flat_fee_enabled"] = flatFeeEnabled ? "0" : "1";
                                                      props[`set${section}FeeStructure`]([...newArray]);
                                                    }}
                                                  />
                                                </div>
                                                <div className="input-box2">
                                                  <Form.Control
                                                    disabled={props[`${sectionName}UniqueFeeEnabled`] == "0" || !flatFeeEnabled}
                                                    style={greyout1}
                                                    size="sm"
                                                    className="cw2"
                                                    placeholder="0"
                                                    value={el.flat_fee ? el.flat_fee : ""}
                                                    onChange={(e) => {
                                                      let newArray = props[`${sectionName}FeeStructure`];
                                                      newArray[index]["flat_fee"] = e.target.value;
                                                      props[`set${section}FeeStructure`]([...newArray]);
                                                    }}
                                                  />
                                                  <span style={{ opacity: flatFeeEnabled ? null : "0.6" }} className="unit">
                                                    $
                                                  </span>
                                                </div>
                                              </div>
                                            </td>
                                            <td className="p-0">
                                              <div className="d-flex pl-2 align-items-center">
                                                <div className="mr-2" style={{ width: "16px" }}>
                                                  <CustomFormCheck
                                                    name={`${sectionName}_fee_structure[][percentage_fee_enabled]`}
                                                    style={greyout}
                                                    disabled={!props[`${sectionName}Enabled`] || props[`${sectionName}UniqueFeeEnabled`] == "0"}
                                                    id={`${section}-ppcagreerev-${index}`}
                                                    checked={percentageEnabled}
                                                    onChange={(e) => {
                                                      let newArray = props[`${sectionName}FeeStructure`];
                                                      newArray[index]["percentage_fee_enabled"] = percentageEnabled ? "0" : "1";
                                                      props[`set${section}FeeStructure`]([...newArray]);
                                                    }}
                                                  />
                                                </div>
                                                <div className="input-box3 pr-4">
                                                  <Form.Control
                                                    name={`${sectionName}_fee_structure[][percentage_fee]`}
                                                    disabled={props[`${sectionName}UniqueFeeEnabled`] == "0" || !percentageEnabled}
                                                    className="primary"
                                                    style={greyout2}
                                                    size="sm"
                                                    placeholder="0"
                                                    value={el.percentage_fee ? el.percentage_fee : ""}
                                                    onChange={(e) => {
                                                      let newArray = props[`${sectionName}FeeStructure`];
                                                      newArray[index]["percentage_fee"] = e.target.value;
                                                      props[`set${section}FeeStructure`]([...newArray]);
                                                    }}
                                                  />
                                                  <span style={{ opacity: percentageEnabled ? null : "0.6" }} className="unit">
                                                    %
                                                  </span>
                                                </div>
                                                {index >= 0 && (
                                                  <i
                                                    onClick={() =>
                                                      removeInnerRow(el.id, props[`${sectionName}Enabled`], props[`${sectionName}UniqueFeeEnabled`])
                                                    }
                                                    className={"fas fa-minus-circle"}></i>
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        );
                                      })}
                                  </tbody>
                                </Table>
                              </div>
                              <Button
                                disabled={!props[`${sectionName}Enabled`] || props[`${sectionName}UniqueFeeEnabled`] == "0"}
                                style={{ 
                                  paddingLeft: "14px",
                                  display: !props[`${sectionName}Enabled`] || props[`${sectionName}UniqueFeeEnabled`] == "0" ? "none" : undefined,
                                  width: "200px",
                                  marginTop: "20px"
                                }}
                                className={"my-3 btn-sm"}
                                variant="success"
                                size="sm"
                                onClick={() => addInnerRow()}>
                                + Add Condition
                              </Button>
                            </Col>

                            <Col className="d-flex flex-column" xs={12} xl={3}>
                              <div style={props[`${sectionName}Enabled`] ? undefined : { display: "none" }}>
                                <PpcSupportingRoles
                                  {...props}
                                  validator={validator}
                                  service={sectionName}
                                  setServiceAccountLeads={props[`set${section}AccountLeads`]}
                                  setServiceAccountSupports={props[`set${section}AccountSupports`]}
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <Row className="mt-5 ">
          <Col className="p-0">
            <Row className="navButtonRow justify-content-center">
              <BackButton />
              <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
              <NextButton
                validated={validated}
                btnText={`Next`}
                nextPage={nextPage.url}
                invalidText={`We need more information on this page before you continue.`}
                submitForm={props.submitForm}
              />
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
}
